/* Click Fencing - edit a saved quote's sections from the Your Quotes panel.
 * Pete 2026-09-01: "go back to edit the quote from this section" and "if this drop down had
 * options to review quote and edit sections".
 *
 * NO SCREENSHOT NEEDED. An image cannot be read back into lengths and gate positions, and
 * nothing extra is needed anyway - the calculator already knows the design. But what
 * proceedToQuotePage SAVES is a reduced copy: num, length, colour, hasGate, hasRaked,
 * gateLength, hingeType, latchType, latchColor, panelLength, gateSide, panels. The LIVE
 * section also carries gapSpacing, gatePosition, gateHingeType, hingeBase, groundPost,
 * panelMode, customPanelOrder and the raw colour value. Rebuilding from the saved copy
 * alone would silently lose the gate position, gap spacing and panel mode - so the full
 * section state is attached as cfDesign when the quote is saved, and the rebuild uses it.
 *
 * Replay drives the REAL controls, never state: assigning state directly leaves dependent
 * fields unset - the trap that produced three false defect reports on 2026-08-31.
 */
(function () {
  'use strict';

  var QUOTES_KEY = {
    '/pages/flat-top-fence-calculator': 'flattop_quotes',
    '/pages/blade-fence-calculator': 'blade_quotes',
    '/pages/perfmesh-fence': 'perfmesh_quotes',
    '/pages/glass-fencing': 'ullc_quotes'
  };
  var PATH_FOR = {
    FlatTop: '/pages/flat-top-fence-calculator',
    Blade: '/pages/blade-fence-calculator',
    PerfMesh: '/pages/perfmesh-fence',
    Frameless: '/pages/glass-fencing'
  };
  var HANDOFF = 'cf-quote-edit';
  var TRIES = 0, MAX_TRIES = 200;

  function inst() { return window.glassCalculator || window.glassFencingCalculator || null; }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function fire(el, ev) { try { el.dispatchEvent(new Event(ev, { bubbles: true })); } catch (e) {} }
  function killPopups() {
    try {
      var b = document.querySelectorAll('button');
      for (var i = 0; i < b.length; i++) if (b[i].textContent.trim() === 'OK') b[i].click();
    } catch (e) {}
  }

  /* ---------- calculator side ---------- */

  function attachDesign(fc) {
    try {
      var key = QUOTES_KEY[location.pathname];
      if (!key) return;
      var design = JSON.parse(JSON.stringify(fc.state.sections || {}));
      var arr = JSON.parse(localStorage.getItem(key) || '[]');
      if (!arr.length) return;
      arr[arr.length - 1].cfDesign = { path: location.pathname, sections: design };
      localStorage.setItem(key, JSON.stringify(arr));
    } catch (e) {}
  }

  function setVal(id, v) {
    var el = document.getElementById(id);
    if (!el || v === undefined || v === null || v === '') return;
    el.value = String(v); fire(el, 'input'); fire(el, 'change');
  }
  function setCheck(id, on) {
    var el = document.getElementById(id);
    if (!el) return;
    if (!!el.checked !== !!on) { el.checked = !!on; fire(el, 'change'); }
  }
  function setRadio(name, v) {
    if (!v) return;
    var els = document.getElementsByName(name);
    for (var i = 0; i < els.length; i++) {
      if (String(els[i].value) === String(v)) { els[i].checked = true; fire(els[i], 'change'); return; }
    }
  }

  async function replay(design) {
    var fc = inst(); if (!fc || !design || !design.sections) return;
    var nums = Object.keys(design.sections).map(Number)
      .filter(function (n) { return !isNaN(n); }).sort(function (a, b) { return a - b; });
    if (!nums.length) return;

    setVal('sections-count', nums.length);
    await wait(1600); killPopups();
    var next = document.getElementById('sections-next-btn');
    if (next) { next.click(); await wait(1900); killPopups(); }

    for (var i = 0; i < nums.length; i++) {
      var n = nums[i], s = design.sections[n];
      if (!s) continue;
      setVal('section-' + n + '-length', s.length);            await wait(900); killPopups();
      setVal('section-' + n + '-panel', s.panelLength);        await wait(600);
      setVal('section-' + n + '-gap', s.gapSpacing);           await wait(600);
      setRadio('section-' + n + '-color', s.color || s.colour);
      await wait(500); killPopups();
      if (s.hasRaked) {
        setCheck('section-' + n + '-raked', true); await wait(1200); killPopups();
        setVal('section-' + n + '-retained-height', s.retainedHeight);
        setRadio('section-' + n + '-raked-side', s.rakedSide);
        await wait(600);
      }
      if (s.hasGate) {
        setCheck('section-' + n + '-gate', true); await wait(1600); killPopups();
        setRadio('section-' + n + '-gate-side', s.gateSide);
        await wait(900); killPopups();
        setVal('section-' + n + '-gate-length', s.gateLength);
        await wait(600);
        // gatePosition has no control - set it, then let the calculator redraw.
        try {
          if (s.gatePosition !== undefined && s.gatePosition !== null && s.gatePosition < 9999) {
            fc.state.sections[n].gatePosition = s.gatePosition;
            delete fc.state.optimizedConfigs[n];
            fc.updateCalculationResults(n);
            fc.renderSectionPreview(n);
          }
        } catch (e) {}
        await wait(500); killPopups();
        // 2026-10-04: a second gate in the section (cf-alu-two-gates.js on Blade / Flat Top /
        // PerfMesh, cf-two-gates.js on glass). Pete: "fix the quote edit one" - editing a saved
        // quote used to bring back gate 1 only. Same rule as above: drive the real controls.
        if (s.hasGate2) {
          var a2 = !!document.getElementById('section-' + n + '-a2g-on');
          var pre = 'section-' + n + (a2 ? '-a2g' : '-g');
          setCheck(a2 ? 'section-' + n + '-a2g-on' : 'section-' + n + '-gate2', true);
          await wait(1200); killPopups();
          setVal(pre + '2-length', s.cfG2Length);                await wait(500);
          setRadio('section-' + n + (a2 ? '-a2g2-side' : '-g2-side'), s.cfG2Side);
          await wait(500);
          [1, 2].forEach(function (g) {
            var P = 'cfG' + g;
            if (s[P + 'From'] != null) setVal(pre + g + '-from', s[P + 'From']);
            if (s[P + 'Mm'] != null && s[P + 'Mm'] !== '') setVal(pre + g + '-mm', s[P + 'Mm']);
            if (s[P + 'Place']) setVal(pre + g + '-place', s[P + 'Place']);
          });
          if (!a2) {   // glass only: what each gate hinges to / latches to
            setVal('section-' + n + '-g1-mount', s.cfG1Mount);
            setVal('section-' + n + '-g2-mount', s.cfG2Mount);
            setVal('section-' + n + '-g1-latchend', s.cfG1LatchEnd);
            setVal('section-' + n + '-g2-latchend', s.cfG2LatchEnd);
          }
          await wait(1200); killPopups();
        }
      }
      // Glass: a single gate hung off a stainless post / chosen mount (cf-two-gates.js).
      if (s.hasGate && !s.hasGate2 && s.cfG1Mount && document.getElementById('section-' + n + '-g1-mount')) {
        setVal('section-' + n + '-g1-mount', s.cfG1Mount); await wait(900); killPopups();
      }
      // Side End Post Setup decides how many posts a section has (customer's choice, Pete 4 Oct).
      if (s.endPostSetup) { setVal('section-' + n + '-end-post-setup', s.endPostSetup); await wait(600); killPopups(); }
    }
    killPopups();
  }

  function checkHandoff() {
    var raw = null;
    try { raw = sessionStorage.getItem(HANDOFF); } catch (e) {}
    if (!raw) return;
    var h = null;
    try { h = JSON.parse(raw); } catch (e) { return; }
    if (!h || h.path !== location.pathname) return;
    try { sessionStorage.removeItem(HANDOFF); } catch (e) {}
    setTimeout(function () { replay(h.design); }, 1200);
  }

  /* ---------- quote-review side ---------- */

  function quoteFor(calcType, num) {
    try {
      var path = PATH_FOR[calcType] || PATH_FOR.Frameless;
      var arr = JSON.parse(localStorage.getItem(QUOTES_KEY[path]) || '[]');
      for (var i = 0; i < arr.length; i++) if (Number(arr[i].quoteNum) === Number(num)) return arr[i];
    } catch (e) {}
    return null;
  }

  function editQuote(calcType, num) {
    var q = quoteFor(calcType, num);
    var path = PATH_FOR[calcType] || PATH_FOR.Frameless;
    if (q && q.cfDesign && q.cfDesign.sections) {
      try {
        sessionStorage.setItem(HANDOFF, JSON.stringify({
          path: q.cfDesign.path || path, design: q.cfDesign, quoteNum: num
        }));
      } catch (e) {}
    } else {
      // Older quote saved before cfDesign existed - open the calculator on its own memory.
      try { alert('This quote was saved before section editing was added, so it will open the calculator without rebuilding it.'); } catch (e) {}
    }
    window.location.href = path;
  }

  function activePill() {
    return document.querySelector('.qr-quote-pill.is-active') ||
           document.querySelector('.qr-quote-pill');
  }

  function addActionRowButton() {
    try {
      var del = document.getElementById('qr-clear-btn');
      if (!del || document.getElementById('cf-edit-sections-btn')) return;
      var pill = activePill();
      if (!pill) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.id = 'cf-edit-sections-btn';
      b.className = 'qr-btn qr-btn--ghost';
      b.textContent = 'Edit sections';
      b.addEventListener('click', function () {
        var p = activePill(); if (!p) return;
        editQuote(p.dataset.calcType, p.dataset.quoteNum);
      });
      del.parentNode.insertBefore(b, del);
    } catch (e) {}
  }

  function decoratePopover() {
    try {
      var pop = document.getElementById('qr-pill-preview-popover');
      if (!pop || !pop.classList.contains('is-visible')) return;
      if (pop.querySelector('[data-cf-pop-actions]')) return;
      var pill = window.__cfHoverPill || activePill();
      if (!pill) return;
      var row = document.createElement('div');
      row.setAttribute('data-cf-pop-actions', '1');
      row.setAttribute('style', 'display:flex;gap:6px;margin-top:10px;');
      function mk(txt, fn) {
        var x = document.createElement('button');
        x.type = 'button';
        x.textContent = txt;
        x.setAttribute('style', 'flex:1;padding:6px 8px;font-size:12px;font-weight:600;' +
          'border:1px solid #cbd5e1;border-radius:6px;background:#fff;color:#0f172a;cursor:pointer;');
        x.addEventListener('click', function (e) { e.stopPropagation(); fn(); });
        return x;
      }
      row.appendChild(mk('Review quote', function () { pill.click(); }));
      row.appendChild(mk('Edit sections', function () {
        editQuote(pill.dataset.calcType, pill.dataset.quoteNum);
      }));
      pop.appendChild(row);
      // Their hidePreview() drops .is-visible 120ms after the pill is left, so keep it
      // alive while the pointer is actually over the card.
      if (!pop.__cfHoverBound) {
        pop.__cfHoverBound = true;
        pop.addEventListener('mouseover', function () { pop.classList.add('is-visible'); });
        pop.addEventListener('mousemove', function () { pop.classList.add('is-visible'); });
      }
    } catch (e) {}
  }

  function initReview() {
    try {
      document.addEventListener('mouseover', function (e) {
        var p = e.target && e.target.closest ? e.target.closest('.qr-quote-pill') : null;
        if (p) window.__cfHoverPill = p;
      }, true);
      var pop = document.getElementById('qr-pill-preview-popover');
      if (window.MutationObserver) {
        new MutationObserver(function () {
          addActionRowButton();
          decoratePopover();
        }).observe(document.body, { childList: true, subtree: true, attributes: true,
                                    attributeFilter: ['class'] });
      }
      addActionRowButton();
      setInterval(function () { addActionRowButton(); decoratePopover(); }, 800);
    } catch (e) {}
  }

  /* ---------- install ---------- */

  function install() {
    if (location.pathname.indexOf('/pages/quote-review') === 0) { initReview(); return true; }
    if (!QUOTES_KEY[location.pathname]) return true;
    var fc = inst();
    if (!fc || !fc.state) return false;
    var P = Object.getPrototypeOf(fc);
    if (P.__cfQuoteEdit) return true;
    if (typeof P.proceedToQuotePage === 'function') {
      var orig = P.proceedToQuotePage;
      P.proceedToQuotePage = function () {
        var r = orig.apply(this, arguments);
        try { attachDesign(this); } catch (e) {}
        return r;
      };
    }
    P.__cfQuoteEdit = true;
    checkHandoff();
    try { console.log('[cf-quote-edit] installed'); } catch (e) {}
    return true;
  }

  function tryInstall() {
    var done = false;
    try { done = install(); } catch (e) {}
    if (done) return;
    if (++TRIES < MAX_TRIES) setTimeout(tryInstall, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInstall);
  } else {
    tryInstall();
  }
})();
